

const ValuerAmendNote = (props) => {

    const value = props.value

    return (
        <div className="valuer-amend-accordion-note">
            {value && value}
        </div>
    )
}

export default ValuerAmendNote;